// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-toolbar {
  box-shadow: var(--toolbar-shadow);
  z-index: 5;
  --background: var(--main-top);
  padding: 0;
  color: var(--main-top-text);
  --ion-toolbar-color: var(--main-top-text);
}
ion-toolbar ion-buttons ion-button.button-clear {
  --color: var(--main-top-text);
  --color: var(--main-top-text);
  --color-activated: var(--main-top-text);
}
ion-toolbar ion-buttons ion-button {
  --border-radius: 0;
  height: 100%;
}

.col-no-padding > ion-col {
  padding: 0px !important;
}

ion-content {
  --background: none;
  --background-image: url('backg2.png');
  background-image: url('backg2.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

ion-toolbar.submain-toolbar {
  --ion-toolbar-color: var(-background-text);
  --background: var(-background);
  --min-height: auto;
}
ion-toolbar.submain-toolbar ::ng-deep ion-segment {
  margin: 0;
}
ion-toolbar.submain-toolbar ::ng-deep ion-segment-button, ion-toolbar.submain-toolbar .md ion-segment-button {
  --color-focused: var(--main-top-text);
  --color-checked: var(--main-top-text);
  --color: var(--main-top-text);
  background: var(--main-top);
}
ion-toolbar.submain-toolbar ::ng-deep.ios ion-segment-button {
  --background-focused: var(--main-top);
  --background-checked: var(--main-top);
  --color-focused: var(--main-top-text);
  --color-checked: var(--main-top-text);
  --color: var(--main-top);
}

ion-menu-button {
  --color: var(--main-top-text);
}

ion-title {
  height: 100%;
}

.menuTab:hover {
  border: 1px solid #0f3f6f;
}

.light-back {
  background-color: #e4e4e4;
}

.bigtext .tabs-body,
.bigtext ion-item,
.bigtext div, .bigtext ion-content, .bigtext ion-row,
.bigtext span, .bigtext ion-icon, .bigtext ion-card-title, .bigtext ion-row,
.bigtext ion-label,
.bigtext ion-item,
.bigtext .item-inner,
.bigtext ion-toolbar,
.bigtext h1, .bigtext h2, .bigtext h3, .bigtext h4,
.bigtext p, .bigtext ion-button, .bigtext div, .bigtext ion-col, .bigtext ion-card-subtitle {
  font-size: 1.4rem;
}

.size1 span {
  font-size: 1.4rem;
}

.size2 span {
  font-size: 0.8rem;
}

.metricCard {
  background: rgb(0, 33, 36);
  background: linear-gradient(145deg, rgb(0, 33, 36) 0%, rgb(9, 121, 114) 1%, rgb(5, 70, 85) 3%, rgb(5, 90, 98) 10%, rgb(5, 114, 179) 41%, rgb(0, 212, 255) 100%);
}

.badgeIcon {
  margin: 8px;
}

.badgeIcon ion-icon {
  float: right;
}

.topflex {
  display: flex;
}

.header,
.footer {
  flex: 1 100%;
}

.sidebar {
  flex: 1;
}

.main {
  flex: 2;
}`, "",{"version":3,"sources":["webpack://./src/app/shaps/taarif/taarif.page.scss"],"names":[],"mappings":"AAIA;EACE,iCAAA;EACA,UAAA;EAEA,6BAAA;EACA,UAAA;EAEA,2BAAA;EACA,yCAAA;AALF;AAOE;EACE,6BAAA;EACA,6BAAA;EACA,uCAAA;AALJ;AAQE;EACE,kBAAA;EACA,YAAA;AANJ;;AAUA;EAEE,uBAAA;AARF;;AAWA;EACE,kBAAA;EACA,qCAAA;EAGA,mCAAA;EACA,4BAAA;EACA,0BAAA;AAVF;;AAaA;EACE,0CAAA;EACA,8BAAA;EACA,kBAAA;AAVF;AAYE;EACE,SAAA;AAVJ;AAYE;EACE,qCAAA;EACA,qCAAA;EAEA,6BAAA;EACA,2BAAA;AAXJ;AAcE;EACE,qCAAA;EACA,qCAAA;EAEA,qCAAA;EACA,qCAAA;EACA,wBAAA;AAbJ;;AAiBA;EACE,6BAAA;AAdF;;AAiBA;EAGE,YAAA;AAhBF;;AA0BA;EACE,yBAAA;AAvBF;;AA0BA;EACE,yBAAA;AAvBF;;AA0BA;;;;;;;;;;EAUE,iBAAA;AAvBF;;AA0BA;EACE,iBAAA;AAvBF;;AA0BA;EACE,iBAAA;AAvBF;;AA0BA;EACE,0BAAA;EACA,+JAAA;AAvBF;;AA0BA;EACE,WAAA;AAvBF;;AA0BA;EACE,YAAA;AAvBF;;AA2BA;EAEE,aAAA;AAzBF;;AA2BA;;EACW,YAAA;AAvBX;;AAwBA;EAAW,OAAA;AApBX;;AAqBA;EAAW,OAAA;AAjBX","sourcesContent":["//@import \"~swiper/css\";\n//@import \"~swiper/css/pagination\";\n//@import \"~swiper/css/navigation\";\n\nion-toolbar {\n  box-shadow: var(--toolbar-shadow);\n  z-index: 5;\n\n  --background: var(--main-top);\n  padding: 0;\n\n  color: var(--main-top-text);\n  --ion-toolbar-color: var(--main-top-text);\n\n  ion-buttons ion-button.button-clear {\n    --color: var(--main-top-text);\n    --color: var(--main-top-text);\n    --color-activated: var(--main-top-text);\n  }\n\n  ion-buttons ion-button {\n    --border-radius: 0;\n    height: 100%;\n  }\n}\n\n.col-no-padding > ion-col\n{\n  padding: 0px !important;\n}\n\nion-content {\n  --background: none;\n  --background-image: url('../../../assets/splash/backg2.png');\n  //background: #fff;\n  //--background: #fff;\n  background-image: url('../../../assets/splash/backg2.png');\n  background-repeat: no-repeat;\n  background-size: 100% 100%;\n}\n\nion-toolbar.submain-toolbar {\n  --ion-toolbar-color: var(-background-text);\n  --background: var(-background);\n  --min-height: auto;\n\n  ::ng-deep ion-segment {\n    margin: 0;\n  }\n  ::ng-deep ion-segment-button, .md ion-segment-button {\n    --color-focused: var(--main-top-text);\n    --color-checked: var(--main-top-text);\n\n    --color: var(--main-top-text);\n    background: var(--main-top);\n  }\n\n  ::ng-deep.ios ion-segment-button {\n    --background-focused: var(--main-top);\n    --background-checked: var(--main-top);\n\n    --color-focused: var(--main-top-text);\n    --color-checked: var(--main-top-text);\n    --color: var(--main-top);\n  }\n}\n\nion-menu-button {\n  --color: var(--main-top-text);\n}\n\nion-title {\n\n  //display: inline-block;\n  height: 100%;\n}\n\n\n\n\nion-content {\n  //background-color: silver;\n}\n\n.menuTab:hover {\n  border: 1px solid #0f3f6f;\n}\n\n.light-back {\n  background-color: #e4e4e4;\n}\n\n.bigtext .tabs-body,\n.bigtext ion-item,\n.bigtext div, .bigtext ion-content, .bigtext ion-row,\n.bigtext span, .bigtext ion-icon, .bigtext ion-card-title, .bigtext ion-row,\n.bigtext ion-label,\n.bigtext ion-item,\n.bigtext .item-inner,\n.bigtext ion-toolbar,\n.bigtext h1, .bigtext h2, .bigtext h3, .bigtext h4,\n.bigtext p, .bigtext ion-button, .bigtext div, .bigtext ion-col, .bigtext ion-card-subtitle {\n  font-size: 1.4rem;\n}\n\n.size1 span {\n  font-size: 1.4rem;\n}\n\n.size2 span {\n  font-size: 0.8rem;\n}\n\n.metricCard {\n  background: rgb(0, 33, 36);\n  background: linear-gradient(145deg, rgba(0, 33, 36, 1) 0%, rgba(9, 121, 114, 1) 1%, rgba(5, 70, 85, 1) 3%, rgba(5, 90, 98, 1) 10%, rgba(5, 114, 179, 1) 41%, rgba(0, 212, 255, 1) 100%);\n}\n\n.badgeIcon {\n  margin: 8px;\n}\n\n.badgeIcon ion-icon {\n  float: right;\n}\n\n\n.topflex\n{\n  display: flex;\n}\n.header,\n.footer  { flex: 1 100%; }\n.sidebar { flex: 1; }\n.main    { flex: 2; }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
